import { combineReducers } from "redux";

import contactus from "../features/admin/contactuss/contactus/Slice";

import farmerdealer from "../features/admin/contactuss/farmer_dealer/Slice";

import common from "../features/admin/common/Slice";

const contactuss = combineReducers({
    contactus,
    farmerdealer,
    common
});

export default contactuss;